import { createTRPCReact } from '@trpc/react-query';
import type { Router } from '@maxretail/sellers-trpc-api/index';

export const trpc = createTRPCReact<Router>();